// extracted by mini-css-extract-plugin
export default {"bgPicked":"dragContent_bgPicked__q6a5D","bgSelected":"dragContent_bgSelected__CEOGp"};